import React from 'react'
import type { FaqEntry } from '@/lib/seo/types'

type Props = {
  faq: FaqEntry[]
}

/**
 * schema.org FAQPage for the SEO FAQ pages.
 *
 * Only emitted for the dedicated FAQ pages — the importer restricts extraction to them,
 * since other pages use h3 for vehicle models and marking those as an FAQ would be false
 * structured data.
 */
const FaqJsonLd = ({ faq }: Props) => {
  if (!faq.length) return null

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map((entry) => ({
      '@type': 'Question',
      name: entry.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: entry.answer,
      },
    })),
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  )
}

export default FaqJsonLd
